'use client';

import { LogoWsLogo20Light, LogoWsLogo50Light, twBreakpoints } from '@woonstad/design-system';
import { useMediaQuery } from '@woonstad/helpers-hooks';
import { usePathname } from 'next/navigation';

export const Logo = () => {
  const pathname = usePathname();
  const isHome = pathname === '/';
  const isLargeViewport = useMediaQuery(twBreakpoints['min-lg']);

  if (isHome && isLargeViewport) {
    return (
      <div className="relative flex h-10 items-center">
        <LogoWsLogo50Light className="h-24 -translate-y-2 max-sm:max-w-full" />
      </div>
    );
  }

  return (
    <LogoWsLogo20Light className="h-10 max-sm:max-w-full" />
  );
};
